import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon } from '@yonderland/andes-icons';
import { ConditionalWrapper, Icon, Link, StackBlock, StackInline, TextAlpha } from '@yonderland/andes-react';
import { useBasketOverviewConfig } from '../../../context/ComponentConfigContext';
export const BasketOverviewAdvantagesBlock = () => {
    const { advantages } = useBasketOverviewConfig();
    if (!advantages) {
        return null;
    }
    return (_jsx(StackBlock, { gap: "3", children: advantages.map(advantage => (_jsxs(StackInline, { wrap: "nowrap", gap: "3", children: [_jsx(Icon, { color: "neutral", source: CheckIcon, size: "sm" }), _jsx(ConditionalWrapper, { condition: !!advantage.link, wrapper: children => (_jsx(Link, { target: advantage.linkOpensInNewTab ? '_blank' : '_self', href: advantage.link, rel: "noreferrer", children: children })), children: _jsx(TextAlpha, { children: advantage.text }) })] }, advantage.text.replace(/ /g, '-')))) }));
};
